export default __webpack_public_path__ + "static/media/logo.2f7d27e5.svg";